import constants from '#packages/constants';
import { getLayout } from './utils/layout';

import type { EditorAPI } from '#packages/editorAPI';
import type { Gap } from './resizeGapsTypes';

export interface Transition {
  update({ deltaY }: { deltaY: number }): void;

  end(): void;

  type:
    | typeof constants.MOUSE_ACTION_TYPES.DRAG_PUSH
    | typeof constants.MOUSE_ACTION_TYPES.RESIZE_PUSH;
}

export const createTransition = (
  editorAPI: EditorAPI,
  gap: Gap,
): Transition => {
  const transitionType = gap.componentBelow
    ? constants.MOUSE_ACTION_TYPES.DRAG_PUSH
    : constants.MOUSE_ACTION_TYPES.RESIZE_PUSH;

  switch (transitionType) {
    case constants.MOUSE_ACTION_TYPES.DRAG_PUSH:
      const moveByAndPushTransition =
        editorAPI.components.layout.moveByAndPushTransition(gap.componentBelow);

      return {
        type: transitionType,
        update: moveByAndPushTransition.update,
        end: moveByAndPushTransition.end,
      };
    case constants.MOUSE_ACTION_TYPES.RESIZE_PUSH:
      const resizeToAndPushTransition =
        editorAPI.components.layout.resizeToAndPushTransition(gap.container);
      const initialHeight = getLayout(editorAPI, gap.container).height;

      return {
        type: transitionType,
        end: resizeToAndPushTransition.end,
        update: ({ deltaY }) =>
          resizeToAndPushTransition.update({ height: initialHeight + deltaY }),
      };
    default:
      throw new Error(`Unsupported transition type: ${transitionType}`);
  }
};
